import { render, staticRenderFns } from "./createCompany.vue?vue&type=template&id=88e3d250&scoped=true"
import script from "./createCompany.vue?vue&type=script&lang=js"
export * from "./createCompany.vue?vue&type=script&lang=js"
import style0 from "./createCompany.vue?vue&type=style&index=0&id=88e3d250&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e3d250",
  null
  
)

export default component.exports